module.exports = __webpack_public_path__ + "static/media/forbidden.dad9466d.svg";